import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setEditId, selectNotificationById } from "../../../store/mine_craft/notificationsSlice";
import { fetchNotification } from "../../../actions/mine_craft/notificationsActions";

import PageLayout from "../_partials/PageLayout";
import SummaryShow from "../../../componets/SummaryShow";
import Details from "./_partials/_Details";
import Tabs from "../../../componets/Tabs";
import Edit from "./Edit";
import { ButtonEdit } from "../../../componets/Buttons";
import SidebarShow from "../Notifications/_partials/_SidebarShow";
import usePermissions from "../../../hooks/usePermissions";

const Show: React.FC = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const notification = useAppSelector(state => id ? selectNotificationById(state, id) : undefined);
  const { write_minecraft } = usePermissions();

  useEffect(() => {
    if (id) {
      dispatch(fetchNotification(id));
    }
  }, [id, dispatch]);

  function onClickEdit() {
    if (notification) {
      dispatch(setEditId(notification.id));
    }
  }

  const renderSubtitle = () => {
    if (!notification) {
      return null;
    }

    return(
      <>
        <div className='v-mb-10'>{notification.subtitle}</div>
        <div>{notification.body}</div>
      </>
    )
  }

  return (
    <PageLayout className='v-notifications-show'>
      <div className='v-container-fluid'>
        <div className='o-header'>
          {
            notification &&
              <SummaryShow
                title={notification.title}
                subtitle={renderSubtitle()}
                createdAt={notification.created_at}
                updatedAt={notification.updated_at}
                actions={write_minecraft ? [
                  <ButtonEdit key='button-edit' onClick={onClickEdit} />
                ] : []}
                className='v-mb-15'
              />
          }

          <Tabs
            paramsKey='tab'
            destroyInactiveTabPane={true}
            items={[
              { label: 'Details', key: 'details', children: <Details notification={notification} /> }
            ]}
          />
        </div>
      </div>

      <Edit />

      <SidebarShow notification={notification} />
    </PageLayout>
  )
}

export default Show;
